import PropTypes from 'prop-types';
import isFunction from 'lodash/isFunction';

export const Conditional = (props) => {
  let condition = props.condition;
  if (isFunction(condition)) {
    condition = condition();
  }
  return condition ? props.children : null;
};

Conditional.propTypes = {
  children: PropTypes.node.isRequired,
  condition: PropTypes.oneOfType([
    PropTypes.bool,
    PropTypes.func,
    PropTypes.number,
    PropTypes.string
  ]),
};

Conditional.defaultProps = {
  condition: true,
};

export default Conditional;



// WEBPACK FOOTER //
// ./src/components/Conditional/index.js